// extracted by css-extract-rspack-plugin
export default {"item":"BqtWLlzthEMg3zGP","disabled":"sx7sqlqidHEa8C9w"};